import React, { SyntheticEvent } from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  Image as CitrusImage,
  JustifyContent,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'
import { onSpaceOrEnter } from '../../utils/accessibility'
import { getDefaultImage, getSrcSet } from '../../utils/formatters'
import { RecipeImage } from '@library/menu-service'

const CenteredImage = withCitrusTheme(CitrusImage, () => ({
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '3px',
}))

const ClickableBox = withCitrusTheme(Box, () => ({ cursor: 'pointer' }))

type RecipeProps = {
  name: string
  image: RecipeImage['crops']
  onClick: (e: SyntheticEvent) => void
}

export const RecipeClickableImage = ({ image, onClick, name }: RecipeProps) => (
  <ClickableBox
    alignItems={AlignItems.Center}
    bg={Color.NeutralGrey_50}
    display={Display.Flex}
    flexDirection={FlexDirection.Column}
    height={['62px', '50px']}
    justifyContent={JustifyContent.SpaceBetween}
    role="button"
    tabIndex={0}
    width="100%"
    onClick={onClick}
    onKeyDown={onSpaceOrEnter(onClick)}
    minWidth={['71px', '62px']}
  >
    <CenteredImage
      alt={name}
      loading="lazy"
      src={getDefaultImage(image)}
      srcSet={getSrcSet(image)}
    />
  </ClickableBox>
)
